export default {
  creditScoreDetails: null
}
